<template>
  <div class="container">
    <Header></header>
    <div class="videoList clear">
      <a
        :href="item.targetLocation" target="_blank"
        class="videoItem"
        v-for="(item,index) in videoList"
        :key="index"
      >
        <img :src="item.image" />
        <h2>{{item.cname}}</h2>
        <div class="content">
          <div class="info">
            <div :class="{icon:true,infos:item.pptStatus}">
              <img src="/static/images/ppt.png">
            </div>
            <span>PPT/作业</span>
          </div>
          <div class="info">
            <div :class="{icon:true,infos:item.guideStatus}">
              <img src="/static/images/guide.png">
            </div>
            <span>实验指导书</span>
          </div>
          <div class="info">
            <div :class="{icon:true,infos:item.deviceStatus}">
              <img src="/static/images/device.png" style="height:12px;width:auto;left:6px;">
            </div>
            <span>实验设备</span>
          </div>
          <div class="info">
            <div :class="{icon:true,infos:item.edaStatus}">
              <img src="/static/images/EDA.png" style="height:8px;width:auto;left:6px;top:11px">
            </div>
            <span>EDA系统</span>
          </div>
        </div>
        <span>{{item.price==0?"免费":"￥"+item.price}}</span>
      </a>
      <p v-if="videoList.length==0">加载中，请稍后...</p>
      <p v-if="videoList===0">暂无数据</p>
    </div>
  </div>
</template>

<script>
import Header from "@/modules/header.vue";
import {getCategories, pageCourse} from "@/assets/js/axios.js";

export default {
  name: "empolyment",

  data() {
    return {
      navbarData: [],
      videoList: []
    };
  },
  components: {
    Header
  },
  created() {
    getCategories().then(data => {
      if (parseInt(data.code) === 1) {
        this.navbarData = data;
        pageCourse(this.navbarData.data[3].ccid)
          .then(data => {
            if (parseInt(data.code) === 1) {
              this.videoList = data.data.dataList;
            }
          });
      } else {
        this.videoList = 0
      }
    })
  }
};
</script>

<style lang="less" scoped>
.container {
  .navbar {
    height: 76px;
    background-color: #fff;
    line-height: 76px;
    text-align: center;
    color: #333;
    font-size: 0;
    a {
      display: inline-block;
      font-size: 20px;
      padding: 0 25px;
      margin: 0 15px;
      height: 74px;
      cursor: pointer;
    }
    .router-link-active {
      color: #25a1fc;
      border-bottom: 2px solid #25a1fc;
    }
  }
  .videoList {
    width: 1200px;
    margin: 20px auto 52px;
    min-height: 414px;
    .videoItem {
      display: block;
      float: left;
      height: 342px;
      width: 282px;
      margin: 20px 24px 0 0;
      background: #fff;
      border-radius: 6px;
      overflow: hidden;
      cursor: pointer;
      &:nth-of-type(4n) {
        margin-right: 0;
      }
      img {
        display: block;
        height: 160px;
        width: 282px;
        background: #ebebeb;
      }
      h2 {
        font-weight: normal;
        font-size: 16px;
        line-height: 24px;
        padding: 3px 20px;
        margin-top: 10px;
        height: 48px;;
      }
        .content {
        height: 60px;
        border-bottom: 1px solid #ececec;
        padding-left:21px;
        .info{
          float: left;
          height: 60px;
          position: relative;
          .icon{
            width: 30px;
            height: 30px;
            border: 15px;
            background-image: url("/static/images/circleg.png");
            background-size: 100% 100%;
            position: absolute;
            left:50%;
            margin-left:-20px;
            img{
              width: 12px;
              height: auto;
              position: relative;
              top:8.5px;
              left:9px;
              background: none;
            }
          }
          .infos{
            background-image: url("/static/images/circleb.png");
          }
          span{
            margin-top:30px;
            color: #333;
            font-size: 12px;
            line-height: 30px;
            margin-right: 10px;
          }
        }
      }
      span {
        line-height: 50px;
        float: right;
        margin-right: 20px;
        font-size: 18px;
        color: #fc291b;
      }
    }
    p {
      text-align: center;
      color: #666;
      line-height: 300px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/employment.vue